import { SchemaModel, StringType, NumberType, ArrayType, DateType, ObjectType, BooleanType } from 'schema-typed';
export default {
  Model: SchemaModel,
  Types: {
    StringType: StringType,
    NumberType: NumberType,
    ArrayType: ArrayType,
    DateType: DateType,
    ObjectType: ObjectType,
    BooleanType: BooleanType
  }
};